export default "__VITE_ASSET__CSrmj7zv__"